import { Grid } from '@mui/material'
import { type Field, PuiTextField } from '@pbt/pbt-ui-components'

import TaxRateTextField from '~/components/dashboard/admin/general/practices/PracticeDetailsSections/tax-configuration/TaxRateTextField'

function TaxConfigurationNameRateRow({
  nameField,
  rateDisabled,
  rateField,
}: {
  nameField: Field
  rateDisabled: boolean
  rateField: Field
}) {
  return (
    <Grid
      container
      item
      alignItems="center"
      columnSpacing={2}
      justifyContent="space-between"
      wrap="nowrap"
      xs={6}
    >
      <Grid item>
        <PuiTextField
          field={nameField}
          inputProps={{ maxLength: 100 }}
          label={nameField.label}
        />
      </Grid>
      <Grid item>
        <TaxRateTextField disabled={rateDisabled} field={rateField} />
      </Grid>
    </Grid>
  )
}

export default TaxConfigurationNameRateRow
